import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card h-100 p-3 shadow-sm" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "small text-muted mb-0" }




export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialCard',
  props: {
    testimonial: {},
    getAssetUrl: { type: Function }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.testimonial.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.getAssetUrl(_ctx.testimonial.logo),
            alt: _ctx.testimonial.company,
            class: "me-3",
            style: {"height":"60px","width":"auto","object-fit":"contain"}
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.testimonial.company), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.testimonial.text), 1)
      ])
    ])
  ]))
}
}

})